import { render } from "./CompleteScoreSavePopup.vue?vue&type=template&id=bee4ed0a&scoped=true&ts=true"
import script from "./CompleteScoreSavePopup.vue?vue&type=script&lang=ts"
export * from "./CompleteScoreSavePopup.vue?vue&type=script&lang=ts"

import "./CompleteScoreSavePopup.vue?vue&type=style&index=0&id=bee4ed0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee4ed0a"]])

export default __exports__